import List from "@/components/list";

const Table = args => {
  const AccountTableConfig = [
    {
      label: "学习名称",
      prop: "className",
      minWidth: "250",
    },{
      label: "学习时长",
      prop: "learnDurationStr",
      minWidth: "120",
    },{
      label: "学习时间",
      prop: "trainTime",
      minWidth: "200",
    },{
      label: "学时",
      prop: "trainHours",
      minWidth: "100",
    }
  ];

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
